import styles from "../CardUsuario/cardUsuario.module.css"
import { CiTrash } from "react-icons/ci";
import { useTranslation } from "react-i18next";

export interface Usuariocard {
    id: string;
    name: string;
    email: string;
    document: string;
    telephone: string;
    image: string | null;
}

interface UsuarioItemProps {
    usuario: Usuariocard;
    deleteUser?: (userId: string) => void;
}

const UsuarioItemAdmin = ({ usuario, deleteUser }: UsuarioItemProps) => {
    const { name, document, email, telephone, image } = usuario;
    const { t } = useTranslation(undefined, { keyPrefix: 'card' });

    return (
        <div className={styles.cardContainer}>
            <div className={styles.usuarioC}>
                {image && <img src={image} alt={name} className={styles.usuarioIm} />}
                <div className={styles.usuarioI}>
                    <div className={styles.nome}>
                        <p><strong>{t('name')}</strong></p>
                        <span>{name}</span>
                    </div>
                    <div className={styles.naonome}>
                        <div>
                            <p><strong>{t('document')}</strong></p>
                            <p>{document}</p>
                        </div>
                        <div>
                            <p><strong>{t('email')}</strong></p>
                            <p>{email}</p>
                        </div>
                        <div>
                            <p><strong>{t('phone')}</strong></p>
                            <p>{telephone}</p>
                        </div>
                    </div>
                </div>
                {deleteUser && <CiTrash className={styles.trash} size={20} onClick={() => deleteUser(usuario.id)} />}
            </div>
        </div>
    );
};

export default UsuarioItemAdmin;
